var _sodipodiNamedview, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlashes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72.973511,
    height: 55.209145,
    viewBox: "0 0 72.973511 55.209145",
    fill: "#000",
    id: "svg4",
    sodipodiDocname: "slashes.svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.733822,
    y: -36.679688,
    width: 18.862499,
    height: 62.455799,
    rx: 9.4312401,
    transform: "rotate(33.5526)",
    id: "rect291"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlashes);
export default __webpack_public_path__ + "static/media/slashes.df9fb17824defbe5e9b3c02526100780.svg";
export { ForwardRef as ReactComponent };